import React from 'react';
import PropTypes from 'prop-types';
import { Button, Col, Row } from "react-bootstrap";
import Loading from '../Loading/Loading';

class FormButtons extends React.Component {

  render() {
    const { saveButtonTitle, isLoading } = this.props
    return (
      <Row style={this.props.style}>
        <Col sm={6} xs={6} lg={6} className="d-flex">
          {
            isLoading ? <Loading /> : (
              <Button type="submit" bsSize="small" bsStyle="success">{saveButtonTitle || "SALVAR"}</Button>
            )
          }
          <Button bsStyle="link" bsSize="small" onClick={() => this.props.history.goBack()}>CANCELAR</Button>
        </Col>
      </Row>
    );
  }
}

FormButtons.propTypes = {
  history: PropTypes.object.isRequired,
  style: PropTypes.object
};

export default FormButtons;


// WEBPACK FOOTER //
// ./src/component/Form/FormButtons.js